import React from 'react'

import { Invoice, PatchRequest, WebEdiDto } from '../../../../data/models'
import { requestPatchInvoiceById, useInvoiceById } from '../../data'
import { InvoiceDto, InvoicePatchDto } from '../../data/model'
import { InvoiceData } from './InvoiceData'

type Props = {
  invoiceId: string
}

export const DataHandlingInvoiceData: React.FC<Props> = ({ invoiceId }) => {
  const { data: invoice, isLoading, mutate } = useInvoiceById(invoiceId)

  const dataToFormValues = (data: WebEdiDto<Invoice>): InvoiceDto => {
    return {
      invoiceNumber: data?.Payload.InvoiceNumber || '',
      deliveryType: data?.Payload.DeliveryType,
      confirmationCode: data?.Payload.ConfirmationCode,
      confirmationId: data?.Payload.ConfirmationId || '',
      confirmationDate: data?.Payload.ConfirmationDate || '',
      deliveryNoteNumber: data?.Payload.DeliveryNoteNumber || '',
      deliveryNoteDate: data?.Payload.DeliveryNoteDate || '',
      department: data?.Payload.SellerInformation.Department || '',
      name: data?.Payload.SellerInformation.Contact?.Name || '',
      phone: data?.Payload.SellerInformation.Contact?.Phone || '',
      email: data?.Payload.SellerInformation.Contact?.Email || '',
      notes: data?.Payload.Notes || '',
    }
  }

  const patchFromFormValues = (
    formData: InvoicePatchDto,
  ): PatchRequest<WebEdiDto<Invoice>> => {
    const patchOperations: PatchRequest<WebEdiDto<Invoice>> = []

    // invoiceNumber
    if (formData.invoiceNumber !== invoice?.Payload.InvoiceNumber) {
      patchOperations.push({
        op: invoice?.Payload.InvoiceNumber ? 'replace' : 'add',
        path: '/Payload/InvoiceNumber',
        value: formData.invoiceNumber,
      })
    }

    // department
    if (formData.department !== invoice?.Payload.SellerInformation.Department) {
      patchOperations.push({
        op: invoice?.Payload.SellerInformation.Department ? 'replace' : 'add',
        path: '/Payload/SellerInformation/Department',
        value: formData.department,
      })
    }

    // name
    if (formData.name !== invoice?.Payload.SellerInformation.Contact?.Name) {
      patchOperations.push({
        op: invoice?.Payload.SellerInformation.Contact?.Name
          ? 'replace'
          : 'add',
        path: '/Payload/SellerInformation/Contact/Name',
        value: formData.name,
      })
    }

    // phone
    if (formData.phone !== invoice?.Payload.SellerInformation.Contact?.Phone) {
      patchOperations.push({
        op: invoice?.Payload.SellerInformation.Contact?.Phone
          ? 'replace'
          : 'add',
        path: '/Payload/SellerInformation/Contact/Phone',
        value: formData.phone,
      })
    }

    // email
    if (formData.email !== invoice?.Payload.SellerInformation.Contact?.Email) {
      patchOperations.push({
        op: invoice?.Payload.SellerInformation.Contact?.Email
          ? 'replace'
          : 'add',
        path: '/Payload/SellerInformation/Contact/Email',
        value: formData.email,
      })
    }

    // notes
    if (formData.notes !== invoice?.Payload.Notes) {
      patchOperations.push({
        op: invoice?.Payload.Notes ? 'replace' : 'add',
        path: '/Payload/Notes',
        value: formData.notes,
      })
    }

    return patchOperations
  }

  const onFormSubmit = async (formData: InvoicePatchDto) => {
    const patchData: PatchRequest<WebEdiDto<Invoice>> =
      patchFromFormValues(formData)
    await requestPatchInvoiceById(invoiceId, patchData)
    mutate()
  }

  return (
    <InvoiceData
      data={dataToFormValues(invoice!)}
      onSubmit={onFormSubmit}
      isLoading={isLoading}
    />
  )
}
